import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaM365AcquisitionsDatabase" */ './lazyIndex'),
    { name: 'OwaM365AcquisitionsDatabase' }
);

export const lazyUpdateDatabaseCachedAcquisitions: LazyAction<
    typeof lazyIndex.updateDatabaseCachedAcquisitions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateDatabaseCachedAcquisitions);

export const lazyWriteToAcquisitionsCacheFromIndexedDb: LazyAction<
    typeof lazyIndex.writeToAcquisitionsCacheFromIndexedDb,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.writeToAcquisitionsCacheFromIndexedDb);

export const lazyWriteCacheMetadata: LazyAction<
    typeof lazyIndex.writeCacheMetadata,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.writeCacheMetadata);

export const lazyReadCacheMetadata: LazyAction<
    typeof lazyIndex.readCacheMetadata,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.readCacheMetadata);

export const lazyValidateCacheTtl: LazyAction<
    typeof lazyIndex.validateCacheTtl,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.validateCacheTtl);

export const lazyInvalidateCache: LazyAction<typeof lazyIndex.invalidateCache, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.invalidateCache);

export const lazyDetectPartialFailure: LazyAction<
    typeof lazyIndex.detectPartialFailure,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.detectPartialFailure);

export const lazyReadCachedAcquisitions: LazyAction<
    typeof lazyIndex.readCachedAcquisitions,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.readCachedAcquisitions);

export const lazyDeleteAcquisitionsDatabase: LazyAction<
    typeof lazyIndex.deleteAcquisitionsDatabase,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.deleteAcquisitionsDatabase);
